import React, { useEffect, useState } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import BlogDetails from "./blog-components/blog-details";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { API_BASE_URL } from "../api/config";
import { withAppData } from "../app/withAppData";

const BlogDetailsPage = (props) => {
  const slug = props.match?.params?.slug;
  const { lang, settings } = props.appData;

  const [loading, setLoading] = useState(true);
  const [post, setPost] = useState(null);
  const [prevPost, setPrevPost] = useState(null);
  const [nextPost, setNextPost] = useState(null);
  const [error, setError] = useState(null);

  const fetchById = async (id) => {
    const res = await fetch(`${API_BASE_URL}/blog/${id}`);
    if (!res.ok) throw new Error("not_found");
    return (await res.json())?.data;
  };

  const fetchNeighbors = async (id) => {
    const res = await fetch(`${API_BASE_URL}/blog/${id}/neighbors`);
    if (!res.ok) return { prev: null, next: null };
    return (await res.json())?.data || { prev: null, next: null };
  };

  const fetchListPage = async (page = 1) => {
    const res = await fetch(`${API_BASE_URL}/blog/list?page=${page}`);
    if (!res.ok) throw new Error("list_failed");
    return (await res.json())?.data?.blogs ?? [];
  };

  const findIdBySlug = async (slug) => {
    let page = 1;
    while (true) {
      const blogs = await fetchListPage(page);
      if (!blogs.length) break;
      const found = blogs.find((b) => b.slug === slug);
      if (found) return found.id;
      page++;
    }
    return null;
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        let id = props.location?.state?.id || null;
        if (!id) {
          id = await findIdBySlug(slug);
          if (!id) throw new Error("not_found");
        }
        const post = await fetchById(id);
        const neighbors = await fetchNeighbors(id);
        setPost(post);
        setPrevPost(neighbors.prev);
        setNextPost(neighbors.next);
      } catch (err) {
        setError("Yazı bulunamadı");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  return (
    <div>
      <Navbar />

      {loading ? (
        <div className="container py-5 text-center">
          <div className="spinner">
            <div className="dot1"></div>
            <div className="dot2"></div>
          </div>
        </div>
      ) : error ? (
        <div className="container py-5">{error}</div>
      ) : (
        <>
          <PageHeader
            lang={lang}
            headertitle={
              post?.translations?.[lang]?.title || post?.slug || "News Details"
            }
            subheader={[
              lang === "en" ? "News" : "Haberler", // sabit “Blog”
              post?.translations?.[lang]?.title || post?.slug || "News Details",
            ]}
          />
          <BlogDetails
            post={post}
            prevPost={prevPost}
            nextPost={nextPost}
            lang={lang}
            settings={settings}
          />
        </>
      )}

      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default withAppData(BlogDetailsPage);
